import React from 'react'
import './Testimonios.css'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import TestimoniosData from '../../Components/Admin/TestimoniosData/TestimoniosData'

export default function Testimonios() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <TestimoniosData />
                </div>
            </section>
        </div>
    )
}



